import React from "react";
import "../css/ScholarshipCycle.css";

const ScholarshipCycle = () => {
  return (
    <section className="scholarship-cycle-section">
      <div className="cycle-container">
        {}
        <div className="cycle-image-side">
          <img
            src="../images/b.jpeg"
            alt="Deserving Students at Sahara"
            className="student-display-img"
          />
        </div>

        {}
        <div className="cycle-text-side">
          <h2 className="cycle-title">Scholarship Cycle</h2>

          <p className="cycle-paragraph">
            At Sahara Public Secondary School, Nepal, scholarships for deserving
            students are offered from Grade 1 to 12. The selection categories
            are diverse, spanning across core academia, active sports talent,
            merit-cum-means assistance, and scientific temperament.
          </p>

          <p className="cycle-paragraph">
            Each academic year, our structured application cycle opens to
            evaluate candidates transparently. The school administration ensures
            that meritorious students from diverse economic backgrounds receive
            an equal opportunity to pursue higher learning and grow in one of
            the premier schools in the region.
          </p>

          <p className="cycle-paragraph font-highlight">
            Explore our continuous scholarship opportunities designed to pave
            the way for your child’s academic excellence and long-term future
            success. Don't miss this opportunity to invest in their education
            and potential. Enquire now about school scholarships and secure a
            brighter tomorrow for your child.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ScholarshipCycle;
